"use strict";

const ColourStudio = () => {
    const init = () => {
        $(function() {
            var $colourStudio = $('.js-colour-studio');
            if($colourStudio.length){
                var $facades = $colourStudio.find('.js-colour-studio-facades');
                var $finishes = $colourStudio.find('.js-colour-studio-finishes');
                var $colours = $colourStudio.find('.js-colour-studio-colours');
                var $finishesForm = $colourStudio.find('.js-finishes-form');
                var $coloursForm = $colourStudio.find('.js-colours-form');
                var $interiorColoursForm = $colourStudio.find('.js-interior-colours-form');
                var $interiorPackages = $colourStudio.find('.js-interior-package');
                var $interiorsSlider = $colourStudio.find('.js-interior-packages');
                var $interiorColours = $colourStudio.find('.js-colour-studio-interior-colours');

                var params = new URLSearchParams(window.location.search);
                if(params.get('facade') !== null){
                    $('html, body').animate({
                        scrollTop: $('.module-exteriors').offset().top
                    }, 100);
                }else if(params.get('package') !== null){
                    $('html, body').animate({
                        scrollTop: $('.module-interiors').offset().top
                    }, 100);
                }else if($('.' + params.get('scrollTo')).length){
                    $('html, body').animate({
                        scrollTop: $('.' + params.get('scrollTo')).offset().top
                    }, 100);
                }
                
                function updateRendivoLink(){
                    var $rendivoLink = $colourStudio.find('.js-rendivo-link');
                    var colour = $colourStudio.find('.js-facade-colour.active').data('id');
                    $rendivoLink.attr('href', '/nsw/facades/' + 
                        $coloursForm.find('input[name="facade"]').val() + 
                        '?style=' + $coloursForm.find('input[name="style"]').val() +
                        '&theme=' + $coloursForm.find('input[name="finish"]').val() + 
                        ',' + colour + '&inclusion=' + colour.replace('TH_DOMNSW', 'INC_DOMNSW')
                    );
                }

                window.scrollToStep2 = function(){
                    $('html, body').animate({
                        scrollTop: $('.module-interiors').offset().top
                    }, 100);
                }

                window.highlightFacade = function($this, id){
                    var $parent = $this.parents('.facade-listing');
                    $colourStudio.find('.facade-listing').removeClass('active');
                    $parent.addClass('active');
                    $colourStudio.find('.js-facade-image').removeClass('active');
                    $colourStudio.find('.js-facade-image[data-id="'+id+'"]').addClass('active');
                }

                window.selectFacade = function(rendivo_id){
                    $finishesForm.find('input[name="facade"]').val(rendivo_id);
                    $finishesForm.find('.ajax-submit').trigger('click');
                    $coloursForm.find('input[name="facade"]').val(rendivo_id);
                }

                window.selectFacadeFinish = function(style, finish){
                    $coloursForm.find('input[name="style"]').val(style);
                    $coloursForm.find('input[name="finish"]').val(finish);
                    $coloursForm.find('.ajax-submit').trigger('click');
                }
                
                window.confirmFacadeFinish = function(){
                    $colourStudio.find('.facade-listing.active button').trigger('click');
                }

                window.selectColour = function($this, id){
                    var $parent = $this.parents('.facade-listing');
                    $colourStudio.find('.facade-listing').removeClass('active');
                    $parent.addClass('active');
                    updateRendivoLink();
                    $colourStudio.find('.js-facade-image').removeClass('active');
                    $colourStudio.find('.js-facade-image[data-id="'+id+'"]').addClass('active');
                }
                
                window.showFinishesSection = function($this, id){
                    $this.siblings('.tab').removeClass('active');
                    $this.addClass('active');
                    $colourStudio.find('.js-finishes-section').removeClass('active');
                    $colourStudio.find('.js-finishes-section[data-id="'+id+'"]').addClass('active');
                    $colourStudio.find('.js-finishes-section[data-id="'+id+'"] .facade-listing:first-child .inner').trigger('click');
                }

                window.goToFacades = function(){
                    $finishes.removeClass('active');
                    $colours.removeClass('active');
                    $facades.addClass('active');
                    $facades.find('.facade-listing:first-child .inner').trigger('click');
                    $('html, body').animate({
                        scrollTop: $facades.offset().top
                    }, 100);
                }

                window.goToFinishes = function(){
                    $facades.removeClass('active');
                    $colours.removeClass('active');
                    $finishes.addClass('active');
                    $finishes.find('.js-finishes-section.active .facade-listing:first-child .inner').trigger('click');
                    $('html, body').animate({
                        scrollTop: $finishes.offset().top
                    }, 100);
                }

                window.goToColours = function(){
                    updateRendivoLink();
                    $facades.removeClass('active');
                    $finishes.removeClass('active');
                    $colours.addClass('active');
                }

                function updateRendivoInteriorLink(){
                    var $rendivoInteriorLink = $colourStudio.find('.js-rendivo-interior-link');
                    var colour = $colourStudio.find('.js-interior-colour.active').data('id');
                    $rendivoInteriorLink.attr('href', '/nsw/interiors/' + 
                        $interiorColoursForm.find('input[name="package"]').val() + 
                        '?theme=' + colour + '&inclusion=' + colour.replace('TH_DOMNSW', 'INC_DOMNSW')
                    );
                }

                window.selectInteriorColour = function($this, id){
                    var $parent = $this.parents('.facade-listing');
                    $colourStudio.find('.facade-listing').removeClass('active');
                    $parent.addClass('active');
                    updateRendivoInteriorLink();
                    $colourStudio.find('.js-interior-image').removeClass('active');
                    $colourStudio.find('.js-interior-image[data-id="'+id+'"]').addClass('active');
                }

                window.goToInteriorPackages = function(){
                    $interiorColours.removeClass('active');
                    $interiorsSlider.addClass('active');
                    $('html, body').animate({
                        scrollTop: $interiorsSlider.offset().top
                    }, 100);
                }

                window.goToInteriorColours = function(){
                    updateRendivoInteriorLink();
                    $interiorsSlider.removeClass('active');
                    $interiorColours.addClass('active');
                }

                $interiorPackages.on('click', function(){
                    $interiorColoursForm.find('input[name="package"]').val($(this).data('id'));
                    $interiorColoursForm.find('.ajax-submit').trigger('click');
                })
            }

            var $colourStudioForm = $('.js-colour-studio-form');
            if($colourStudioForm.length){
                $colourStudioForm.find('[name="consultant"]').parents('.form-group').hide();

                $colourStudioForm.find('[name="spoken"]').on('change', function(){
                    if($(this).val() == 'Yes'){
                        $colourStudioForm.find('[name="consultant"]').parents('.form-group').css('display', '');
                    }else{
                        $colourStudioForm.find('[name="consultant"]').parents('.form-group').hide();
                    }
                });
            }
        });
    };

    return {
        init: init,
    };
};

export default ColourStudio;